import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { di } from 'react-magnetic-di';
import { ConnectedReactionsView, ReactionUpdateType } from '@atlaskit/reactions';
import { fireTrackAnalytics } from '@atlassian/analytics-bridge';
import { JiraCommentAri, JiraIssueAri } from '@atlassian/ari/jira';
import { triggerJiraReactionLoadedAnalytics, triggerJiraReactionsUpdatedAnalytics, useCreateFireAnalyticsFromTrigger } from '../../../../../utils/analytics';
import { ReactionsPlaceholder } from '../../../reactions-placeholder';
import { QUICK_EMOJI_IDS, QUICK_PICK_EMOJI_IDS } from './constants';
import { reactionStoreFactory } from './utils';
export var ReactionsBar = function ReactionsBar(_ref) {
  var commentAri = _ref.commentAri,
    issueAri = _ref.issueAri,
    emojiProvider = _ref.emojiProvider,
    experienceTrackingAttributes = _ref.experienceTrackingAttributes,
    handleMarkAsRead = _ref.handleMarkAsRead,
    projectId = _ref.projectId,
    projectType = _ref.projectType;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isReady = _useState2[0],
    setIsReady = _useState2[1];
  var reactionsStore = useMemo(function () {
    return reactionStoreFactory();
  }, []);
  var fireReactionsUpdatedAnalytics = useCreateFireAnalyticsFromTrigger(triggerJiraReactionsUpdatedAnalytics);
  var fireReactionsLoadedAnalytics = useCreateFireAnalyticsFromTrigger(triggerJiraReactionLoadedAnalytics);
  var checkReactionsState = useCallback(function () {
    var state = reactionsStore.getState().reactions["".concat(issueAri, "|").concat(commentAri)];
    setIsReady((state === null || state === void 0 ? void 0 : state.status) === 'READY');
  }, [reactionsStore, issueAri, commentAri]);
  useEffect(function () {
    if (isReady) {
      fireReactionsLoadedAnalytics({
        notification: experienceTrackingAttributes.notification,
        listIndex: experienceTrackingAttributes.listIndex,
        commentId: JiraCommentAri.parse(commentAri).resourceId,
        issueId: JiraIssueAri.parse(issueAri).resourceId,
        projectId: projectId,
        projectType: projectType === null || projectType === void 0 ? void 0 : projectType.toLowerCase()
      });
    }
  }, [commentAri, experienceTrackingAttributes.listIndex, experienceTrackingAttributes.notification, fireReactionsLoadedAnalytics, isReady, issueAri, projectId, projectType]);
  useEffect(function () {
    reactionsStore.onChange(checkReactionsState);
    checkReactionsState();
    return function () {
      reactionsStore.removeOnChangeListener(checkReactionsState);
    };
  }, [checkReactionsState, reactionsStore]);
  var wrapperRef = useRef(null);
  var reactionSuccessEvent = useCallback(function (action, targetAri, emojiId, reactionsCount) {
    if (wrapperRef.current) {
      var firstButton = wrapperRef.current.querySelector('button');
      if (firstButton) {
        firstButton.focus();
      }
    }
    var reactionCountHierarchy = reactionsCount > 1 ? 1 : 0;
    fireReactionsUpdatedAnalytics({
      notification: experienceTrackingAttributes.notification,
      listIndex: experienceTrackingAttributes.listIndex,
      commentId: JiraCommentAri.parse(targetAri).resourceId,
      issueId: JiraIssueAri.parse(issueAri).resourceId,
      emojiId: emojiId,
      action: action,
      reactionCountHierarchy: action === ReactionUpdateType.added ? reactionCountHierarchy : undefined,
      projectId: projectId,
      projectType: projectType === null || projectType === void 0 ? void 0 : projectType.toLowerCase()
    });
    handleMarkAsRead();
  }, [fireReactionsUpdatedAnalytics, experienceTrackingAttributes.notification, experienceTrackingAttributes.listIndex, issueAri, projectId, projectType, handleMarkAsRead]);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, !isReady && /*#__PURE__*/React.createElement(ReactionsPlaceholder, null), /*#__PURE__*/React.createElement("span", !isReady && {
    style: spanStyle
  }, /*#__PURE__*/React.createElement(ConnectedReactionsView, {
    ari: commentAri,
    containerAri: issueAri,
    store: reactionsStore,
    emojiProvider: emojiProvider,
    allowAllEmojis: true,
    pickerQuickReactionEmojiIds: QUICK_PICK_EMOJI_IDS,
    quickReactionEmojis: {
      ari: commentAri,
      containerAri: issueAri,
      emojiIds: QUICK_EMOJI_IDS
    },
    onReactionSuccess: reactionSuccessEvent
  })));
};
var spanStyle = {
  display: 'none'
};